<div class="main-content datos-personales-page">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10">
        <section class="datos-card">
          <div class="datos-card__header">
            <div class="datos-card__title">
              <i class="material-icons">shield</i>
              <span>Seguridad de la cuenta</span>
            </div>
          </div>

          <form [formGroup]="formGroupUsuario" class="datos-card__body">
            <div class="row datos-grid datos-grid--single">
              <div class="col-12">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="passwd">Contraseña actual</label>
                  <mat-form-field appearance="outline" class="datos-field datos-field--with-errors">
                    <mat-icon matPrefix>lock_outline</mat-icon>
                    <input
                      id="passwd"
                      type="password"
                      name="passwd"
                      maxlength="20"
                      matInput
                      [(ngModel)]="usuarioObj.password"
                      oninput="this.value = this.value.trim()"
                      formControlName="ctrlPasswd"
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="newPasswd">Nueva contraseña</label>
                  <mat-form-field appearance="outline" class="datos-field datos-field--with-errors">
                    <mat-icon matPrefix>enhanced_encryption</mat-icon>
                    <input
                      id="newPasswd"
                      type="password"
                      name="newPasswd"
                      maxlength="20"
                      matInput
                      [(ngModel)]="usuarioObj.newPassword"
                      oninput="this.value = this.value.trim()"
                      formControlName="ctrlNewPasswd"
                    >
                    <mat-error *ngIf="formUsuar.ctrlNewPasswd.dirty && formUsuar.ctrlNewPasswd.errors">
                      La contraseña debe tener al menos 6 caracteres
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="confPasswd">Confirmar contraseña</label>
                  <mat-form-field appearance="outline" class="datos-field datos-field--with-errors">
                    <mat-icon matPrefix>verified_user</mat-icon>
                    <input
                      id="confPasswd"
                      type="password"
                      name="confPasswd"
                      maxlength="20"
                      matInput
                      [(ngModel)]="confirmaPass"
                      oninput="this.value = this.value.trim()"
                      formControlName="ctrlConfPasswd"
                    >
                    <mat-error *ngIf="formUsuar.ctrlConfPasswd.dirty && formUsuar.ctrlConfPasswd.errors">
                      Las contraseñas no coinciden
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="datos-inline-note">
              <div class="datos-inline-note__icon">
                <i class="material-icons">shield</i>
              </div>
              <span>Usa una contraseña de al menos 6 caracteres y evita reutilizar claves anteriores.</span>
            </div>

            <div class="datos-card__divider"></div>

            <div class="datos-card__actions">
              <button
                type="button"
                mat-raised-button
                class="btn datos-btn datos-btn--secondary"
                (click)="cancelar()"
              >
                Cancelar
              </button>

              <button
                type="button"
                mat-raised-button
                class="btn datos-btn datos-btn--primary"
                [disabled]="formGroupUsuario.invalid"
                (click)="actualizaPass()"
              >
                Guardar cambios
              </button>
            </div>
          </form>
        </section>

        <section class="datos-support">
          <div class="datos-support__icon">
            <i class="material-icons">security</i>
          </div>

          <div class="datos-support__copy">
            <strong>Mantén segura tu cuenta</strong>
            <span>Si detectas accesos no reconocidos o problemas para actualizar tu contraseña, contacta a Sistemas.</span>
          </div>

          <div class="datos-support__cta">Seguridad</div>
        </section>
      </div>
    </div>
  </div>
</div>
